import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { GetMoneyPursesPayload } from "../../payload/GetMoneyPurses/GetMoneyPursesPayload";

const getMoneyPursesFetch = (state: FinanceState, action: PayloadAction<GetMoneyPursesPayload>) => {
    state.isLoading = true;
}

export default getMoneyPursesFetch;